import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { AppRoutes } from '../../../constants/routes';

const PortfolioCard = ({ work }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minWidth: 260,
        minHeight: 260,
        borderRadius: '15px',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundImage: `url(${work.image.url})`,
        cursor: 'pointer',

        '@media (max-width: 576px)': {
          width: 145,
          height: 145,
        },
      }}
      onClick={() => {
        navigate(`${AppRoutes.WORKS.route}/${work.slug}`);
      }}
    />
  );
};

export default PortfolioCard;
